module.exports = __webpack_public_path__ + "static/img/passo1.5b8760b6.svg";